export const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/Login.vue')
  },
  {
    path: '/sso/callback',
    name: 'sso-callback',
    component: () => import('./views/Callback.vue')
  }
]
